import { kebabToCamelCase } from "~/utils/common";

export type TTranslationItem = {
  key: string;
  translation: string;
};

const translationHasKey = (key: string) => (item: TTranslationItem) =>
  item.key === key;

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const route = useRoute();
  const translations = config?.public?.translations;

  const getTranslate = (key: string): string => {
    const isEnglish = route.params?.lang === "en";
    const generalKey = isEnglish ? "defaultEn" : "default";
    const specificKey = `${kebabToCamelCase(route.params?.cinemaslug)}${
      isEnglish ? "En" : ""
    }`;

    const hasRequestedKey = translationHasKey(key);
    const specificTranslation = (translations[specificKey] ?? []).find(
      hasRequestedKey,
    )?.translation;
    const generalTranslation = (translations[generalKey] ?? []).find(
      hasRequestedKey,
    )?.translation;

    return specificTranslation || generalTranslation || key;
  };

  return {
    provide: {
      getTranslate,
    },
  };
});
